export const representativeWidget = {
	center: true,
	items: 5,
	loop: true,
	stagePadding: 40,
	margin: 0,
	nav: false,
	responsive: {
		0: {
			items: 2,
			stagePadding: 40,
		},
		376: {
			items: 3,
			stagePadding: 40,
		},
		541: {
			items: 4,
			stagePadding: 40,
		},
	},
};
